import script from "./CompContract.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompContract.vue?vue&type=script&setup=true&lang=ts"

import "./CompContract.vue?vue&type=style&index=0&id=50043be6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50043be6"]])

export default __exports__